// extracted by mini-css-extract-plugin
module.exports = {"container":"container-16Mm0QNVirE6nRe-ktCFFy","message":"message-3mFj7wQshCgEUwrY39MUEQ","description":"description-o_zoz95PdkQZ-uSl90Tt4","image":"image-ICqkdUvQHPLzVoZqH24sL"};